import Box from '@mui/material/Box';
import ImageRenderProps from './image-render-props';

export default function ImageRender({ id, src, sx }: ImageRenderProps) {
	return (
		<Box
			id={id}
			key={id}
			sx={{ display: 'flex', justifyContent: 'center', img: { display: 'flex' }, ...sx }}
		>
			<img src={src} alt="We Need A Sample ALT" />
		</Box>
	);
}
